import { render } from "./seeCurrentStats.vue?vue&type=template&id=49cabb3a&scoped=true"
import script from "./seeCurrentStats.vue?vue&type=script&lang=js"
export * from "./seeCurrentStats.vue?vue&type=script&lang=js"

import "./seeCurrentStats.vue?vue&type=style&index=0&id=49cabb3a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cabb3a"]])

export default __exports__